import type { RunConfigStatus } from '@xpanse/ui';

import { useQuery } from '@tanstack/react-query';

import { RunConfigService } from 'src/utils/api';

export const getRunStatus = async (runConfigId: string): Promise<RunConfigStatus> => {
  try {
    const response = await RunConfigService.getRunConfigStatus(runConfigId!);
    return {
      status: response.status,
    };
  } catch (error) {
    return {
      // TODO: Added status as this is required.
      status: 'FAILED',
      error: error instanceof Error ? error.message : 'Failed to load summary',
    };
  }
};

export const useRunStatus = (runConfigId: string) => {
  const { data, isFetching } = useQuery({
    queryKey: ['status', runConfigId],
    queryFn: () => getRunStatus(runConfigId),
    enabled: !!runConfigId,
  });

  return {
    summaryStatus: data?.status || '',
    error: data?.error,
    isFetchingStatus: isFetching,
  };
};
